import { Columns } from '@shared/interfaces/table/column-config';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';

/**
 * ProductCharacteristicIdentification Partial Translation Cell
 * Translates productCharacteristicIdentification enum into understandable values
 */
export const productCharacteristicIdentificationPartial: Columns<any> = {
  title: 'Produkt',
  key: 'productCharacteristicIdentification',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    notspecified: 'enum.meteringpoint.productcharacteristic.notspecified',
    tariff: 'enum.meteringpoint.productcharacteristic.tariff',
    fuelquantity: 'enum.meteringpoint.productcharacteristic.fuelquantity',
    poweractive: 'enum.meteringpoint.productcharacteristic.poweractive',
    powerreactive: 'enum.meteringpoint.productcharacteristic.powerreactive',
    energyactive: 'enum.meteringpoint.productcharacteristic.energyactive',
    energyreactive: 'enum.meteringpoint.productcharacteristic.energyreactive',
  }
}
